import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';
import { TopAdsFiltersProps } from '../../types';
import TopAdsFiltersDatePicker from './TopAdsFilters.DatePicker';
import TopAdsFiltersStaticCopy from './TopAdsFilters.StaticCopy';
import TopAdsFiltersCategories from './TopAdsFilters.Categories';

const FiltersContainer = styled.div`
  padding: 12px 32px;
  background-color: ${colors.neutral0};
  width: calc(100% + 64px);
  margin: -32px 0 0 -32px;
  display: flex;
  border-bottom: 1px solid ${colors.neutral20};

  & > div {
    flex: 1;
    gap: 12px;
    display: flex;

    &:first-of-type {
      justify-content: flex-start;
    }

    &:last-of-type {
      justify-content: flex-end;
    }
  }
`;

const FiltersRight = styled.div``;

const FiltersLeft = styled.div``;

const TopAdsFiltersView = (props: TopAdsFiltersProps) => (
  <FiltersContainer>
    <FiltersRight>
      <TopAdsFiltersStaticCopy />
    </FiltersRight>
    <FiltersLeft>
      <TopAdsFiltersCategories {...props} />
      <TopAdsFiltersDatePicker {...props} />
    </FiltersLeft>
  </FiltersContainer>
);

export default TopAdsFiltersView;
